import { observer } from 'mobx-react-lite'
import { FirstStep } from 'page/ProfileScreen/BasicSelfiesPanel/FirstStep'
import { FourthStep } from 'page/ProfileScreen/BasicSelfiesPanel/FourthStep'
import { FullbodyStep } from 'page/ProfileScreen/BasicSelfiesPanel/FullbodyStep'
import { SecondStep } from 'page/ProfileScreen/BasicSelfiesPanel/SecondStep'
import { ThirdStep } from 'page/ProfileScreen/BasicSelfiesPanel/ThirdStep'
import { TypeStep } from 'page/ProfileScreen/BasicSelfiesPanel/TypeStep'
import { UploadStep } from 'page/ProfileScreen/BasicSelfiesPanel/UploadStep'
import { store } from 'store/store'

export const BasicSelfiesPanel = observer(() => {
  const { step } = store.profile.basic

  switch (step) {
    case 'type':
      return <TypeStep />
    case 'first':
      return <FirstStep />
    case 'fullbody':
      return <FullbodyStep />
    case 'second':
      return <SecondStep />
    case 'third':
      return <ThirdStep />
    case 'fourth':
      return <FourthStep />
    case 'upload':
      return <UploadStep />
  }
})
